import React from 'react';
import { TrafficLayer } from "@react-google-maps/api";
const TrafficLayerMap = () => <TrafficLayer />;
export default TrafficLayerMap;
